module.exports = __webpack_public_path__ + "static/media/QR-google-play.78d09477.png";